<template>
  <div>
    <a-button type="primary" @click="showAddProcess" v-if="ableAdd" style="margin-bottom: 20px">添加流程</a-button>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑流程' : '添加流程'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-process
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
      ></add-process>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, processType) }}
        </template>
        <template v-if="column.key === 'process_definition'">
          {{ record?.process_definition?.name || '' }}
        </template>
        <template v-if="column.key === 'remark'">
          {{ record?.process_definition?.remark || '' }}
        </template>
        <template v-if="column.key === 'create_user'">
          {{ record?.create_user?.user_name || '' }}
        </template>
        <template v-if="column.key === 'create_time'">
          {{ record?.process_definition?.create_time || '' }}
        </template>

        <template v-if="column.key === 'action'">
          <span>
            <a-button @click="showEditProcess(record)" v-if="ableEdit">编辑</a-button>
            &nbsp;&nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getProc, deleteProc } from '@/api/process'
  import AddProcess from './addProcess'
  import { message } from 'ant-design-vue'
  import { processType } from '@/utils/common'
  import { codeToText } from '@/utils/format'
  const store = useStore()

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'process:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'process:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'process:delete')
  )
  
  //1、表格
  const columns = [
    {
      title: '流程',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      align: 'left',
    },
    {
      title: '关联的流程定义',
      dataIndex: 'process_definition',
      key: 'process_definition',
      align: 'left',
    },
    // {
    //   title: '备注',
    //   dataIndex: 'remark',
    //   key: 'remark',
    //   align: 'left',
    // },
    {
      title: '创建人',
      dataIndex: 'create_user',
      key: 'create_user',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '190px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }



  function fetch() {
    loading.value = true
    getProc({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //2、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAddProcess = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEditProcess = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //3、删除
  async function delRow(data) {
    const res = await deleteProc({ processId: data.process_id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
